export default function Detail({ children, borderbVisible = true }) {
  const borderb = borderbVisible ? 'border-b border-[#EEEEEE]' : ''
  return (
    <div className={ cn('md:max-w-[50rem] mt-2 pb-14 mx-auto', borderb) }>
      { children }
    </div>
  )
}
